// extracted by mini-css-extract-plugin
module.exports = {"Textarea":"Textarea_Textarea__yrtix","textareaTextColor":"Textarea_textareaTextColor__VnNo6","focused":"Textarea_focused__v7XIq"};